import { Box, useTheme } from '@mui/material';
import React from 'react';

import { defaultTableStyles } from '../../../utils/tables';

interface IProps {
  text: string | undefined;
}

export const PlainCell: React.FC<IProps> = ({ text }) => {
  const theme = useTheme();
  const { ellipsisContainer } = defaultTableStyles(theme);

  return <Box sx={ellipsisContainer}>{text || ''}</Box>;
};
